import { Location } from '@freelancer/location';
import { take } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "../location/location.service";
import * as i2 from "@angular/common";
import * as i3 from "./link-tags.config";
/**
 * LinkTags is a service that allows the insertion of links into the HEAD section
 * of a page.
 */
var LinkTags = /** @class */ (function () {
    function LinkTags(location, doc, siteWideConfig) {
        this.location = location;
        this.doc = doc;
        this.siteWideConfig = siteWideConfig;
    }
    /**
     * Adds a link to the HEAD section of the current page.
     */
    LinkTags.prototype.addLink = function (tag) {
        var link = this.doc.createElement('link');
        if (tag.rel) {
            link.setAttribute('rel', tag.rel);
        }
        if (tag.href) {
            link.setAttribute('href', tag.href);
        }
        if (tag.itemprop) {
            link.setAttribute('itemprop', tag.itemprop);
        }
        if (tag.title) {
            link.setAttribute('title', tag.title);
        }
        if (tag.type) {
            link.setAttribute('type', tag.type);
        }
        this.doc.head.appendChild(link);
    };
    /**
     * Sets the link tags that will be used on all pages using the site wide
     * link tags configuration.
     */
    LinkTags.prototype.setSiteWideLinks = function () {
        var _this = this;
        if (this.siteWideConfig) {
            Object.values(this.siteWideConfig).forEach(function (linkTag) {
                _this.addLink(linkTag);
            });
        }
    };
    /**
     * Sets the canonical link for the current page.
     */
    LinkTags.prototype.setCanonicalLink = function (href) {
        var _this = this;
        // Canonical url tells search engines that the specific url is the master
        // copy of that page.
        this.location
            .valueChanges()
            .pipe(take(1))
            .toPromise()
            .then(function (location) {
            _this.addLink({ rel: 'canonical', href: "" + location.origin + href });
        });
    };
    LinkTags.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LinkTags_Factory() { return new LinkTags(i0.ɵɵinject(i1.Location), i0.ɵɵinject(i2.DOCUMENT), i0.ɵɵinject(i3.SITE_WIDE_LINK_TAGS, 8)); }, token: LinkTags, providedIn: "root" });
    return LinkTags;
}());
export { LinkTags };
